export type TrackMap = Record<string, string>;

export const groupChatIdPrefix = "sip:chat;group=sip:";

export function readAsDataURL(file: File): Promise<string> {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    return new Promise((resolve) => {
        reader.addEventListener("loadend", (ev) => {
            resolve(ev.target.result as string);
        });
    });
}

export function loadImage(dataURL: string): Promise<HTMLImageElement> {
    const image = new Image();
    image.src = dataURL;
    return new Promise((resolve) => {
        image.addEventListener("load", (_ev) => {
            resolve(image);
        });
    });
}

export function getCanvasBlob(canvas: HTMLCanvasElement, type?: string): Promise<Blob> {
    return new Promise<Blob>((resolve) => {
        canvas.toBlob(resolve, type);
    });
}

export async function generateImageThumbnail(file: File, bound: number): Promise<Blob> {
    const data = await readAsDataURL(file);
    const image = await loadImage(data);

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    const scaleRatio = bound / Math.max(image.width, image.height);
    const w = image.width * scaleRatio;
    const h = image.height * scaleRatio;
    canvas.width = w;
    canvas.height = h;
    ctx.drawImage(image, 0, 0, w, h);

    return await getCanvasBlob(canvas, file.type);
}

export function getNameLetters(name: string): string {
    const parts = name.split(" ");
    if (parts.length === 1) return name.substring(0, 2);
    return parts
        .slice(0, 2)
        .map((p) => p[0])
        .join("");
}

export const sidebarWidth = 250;
